<div class="platform-content-container">
    <h1 class="solcitare-title">Adaugă conținut platformă</h1>
    <form
      class="platform-content-card__form"
      [formGroup]="form"
      (submit)="submitForm()"
    >
      <div class="platform-content">
        <mat-form-field appearance="fill">
          <mat-label>Titlu</mat-label>
          <input type="text" matInput formControlName="title" />
        </mat-form-field>
        <mat-error
          *ngIf="!form.controls['title'].valid && form.controls['title'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </div>
      <div class="platform-content">
        <mat-form-field appearance="fill">
          <mat-label>Slug</mat-label>
          <input type="text" matInput formControlName="slug" />
        </mat-form-field>
        <mat-error
          *ngIf="!form.controls['slug'].valid && form.controls['slug'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </div>
      <div class="platform-content">
        <mat-form-field appearance="fill">
          <mat-label>Conținut</mat-label>
          <input type="text" matInput formControlName="content" />
        </mat-form-field>
        <mat-error
          *ngIf="!form.controls['content'].valid && form.controls['content'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </div>
      <div class="platform-content">
        <mat-form-field appearance="fill">
          <mat-label>Observații</mat-label>
          <input type="text" matInput formControlName="observations" />
        </mat-form-field>
        <mat-error
          *ngIf="!form.controls['observations'].valid && form.controls['observations'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </div>
      <div class="platform-content">
        <mat-form-field appearance="fill">
          <mat-label>ID secțiune</mat-label>
          <input type="text" matInput formControlName="section_id" />
        </mat-form-field>
        <mat-error
          *ngIf="!form.controls['section_id'].valid && form.controls['section_id'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </div>
      <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
      <div class="platform-content-action-btns">
        <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
          Close
        </button>
        <button class="buttons" mat-flat-button color="primary" type="submit">
          Save
        </button>
      </div>
    </form>
  </div>
